import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/authStore';
import { queryKeys } from './queryKeys';

export interface VehicleHistorySummaryData {
  customerSummary: string | null;
  internalSummary: string | null;
}

export function historySummaryLanguage(language: string | undefined): 'fi' | 'en' {
  return (language ?? 'fi').toLowerCase().startsWith('fi') ? 'fi' : 'en';
}

export function useVehicleHistorySummary(vehicleId: string | undefined, language: 'fi' | 'en') {
  const user = useAuthStore((state) => state.user);
  const sessionEpoch = useAuthStore((state) => state.sessionEpoch);
  return useQuery({
    queryKey: [...queryKeys.vehicles.detail(vehicleId ?? ''), 'ai-history-summary', user?.tenantId, user?.id, sessionEpoch, language],
    queryFn: ({ signal }) => api.get<VehicleHistorySummaryData>(`/vehicles/${vehicleId}/history-summary`, {
      params: { language }, signal,
    }),
    // Fetch as soon as an existing vehicle is known. A permissions gate here
    // left the query idle and the UI looking empty (#2888).
    enabled: Boolean(vehicleId),
    staleTime: 5 * 60 * 1000,
    // Avoid repeated AI calls when the user changes steps or refocuses the window.
    refetchOnWindowFocus: false,
    retry: false,
  });
}
